import { render } from "./loading.vue?vue&type=template&id=62f2e5c2&scoped=true"
import script from "./loading.vue?vue&type=script&lang=js"
export * from "./loading.vue?vue&type=script&lang=js"

import "./loading.vue?vue&type=style&index=0&id=62f2e5c2&lang=scss&rel=stylesheet%2Fscss&scoped=true"
script.render = render
script.__scopeId = "data-v-62f2e5c2"

export default script